
<template>
    <div style="border: 0px solid black; width:100%;">
        <div class="welcome" style="border: 0px solid red;">
            <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
                <div class="box box-success">
                    <div class="box-header with-border">
                        <h3 class="box-title">{{$t('search.title')}}</h3>
                    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <div class="input-group date">
                                        <div class="input-group-addon">
                                            <i class="fa fa-calendar">
                                                <label>
                                                <span
                                                    style="margin-left:5px;display:inline-block;"
                                                >{{$t('service_history.date_from')}}:</span>
                                                </label>
                                            </i>
                                        </div>
                                        <date-picker
                                            :config="options"
                                            :value="search.from_date"
                                            v-model="search.from_date"
                                        ></date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <div class="input-group date">
                                        <div class="input-group-addon">
                                            <i class="fa fa-calendar">
                                                <label>
                                                <span
                                                    style="margin-left:5px;display:inline-block;"
                                                >{{$t('service_history.date_to')}}:</span>
                                                </label>
                                            </i>
                                        </div>
                                        <date-picker
                                            :config="options"
                                            :value="search.to_date"
                                            v-model="search.to_date"
                                        ></date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('invoice.einvoice.apartment_code')"
                                        v-model="search.apartment_code"
                                    />
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <select v-model="search.booking_status" class="form-control">
                                    <option
                                        v-for="booking_status in booking_status_list"
                                        v-bind:value="booking_status.id"
                                        :key="booking_status.id"
                                        >{{$t(booking_status.text)}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('apartmentbookings.booking_code')"
                                        v-model="search.booking_code"
                                    />
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('project_history.full_name')"
                                        v-model="search.full_name"
                                    />
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <select v-model="search.domestic_customer" class="form-control">
                                    <option
                                        v-for="nation in nations"
                                        v-bind:value="nation.id"
                                        :key="nation.id"
                                        >{{$t(nation.text)}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('apartmentbookings.apartment_leaseback_clients.flight')"
                                        v-model="search.flight_no"
                                    />
                                </div>
                            </div>
                            <div class="col-sm-3 col-md-3 col-lg-3">
                                <div class="form-group">
                                    <input
                                        @change="onChangeStatusBreakfast"
                                        type="checkbox"
                                        :checked="isHasBreakfast"
                                    />
                                    {{$t('leaseback_resident_client.has_breakfast')}}
                                </div>
                            </div>
                            <div style="margin-right: 15px;">
                                <button
                                type="button"
                                class="btn btn-labeled btn-success pull-right"
                                @click="onSearchApartmentClientBooking($event)"
                                >
                                    <span class="btn-label">
                                        <i class="glyphicon glyphicon-search"></i>
                                    </span>
                                    {{$t('search.search_button')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box box-primary" style="width:100%">
                    <div class="box-header with-border">
                        <div
                        style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
                        >
                            <b>{{$t('sidebar.leasebackmanagement.resident_clients')}}</b>
                            <lte-button
                                style="float:right;background-color:white !important;"
                                type="btn btn-default"
                                right_icon="fa fa-download"
                                @click="onExport($event, 1)"
                            >{{$t('leaseback_resident_client.export_information_for_residents')}}</lte-button>
                            <lte-button
                                style="float:right;background-color:white !important;"
                                type="btn btn-default"
                                right_icon="fa fa-download"
                                @click="onExport($event, 2)"
                            >{{$t('leaseback_resident_client.export_information_on_display')}}</lte-button>
                        </div>
                        <select-option-check
                            style="margin-top:-40px;"
                            :item="columnsApartment"
                            class="dropdown-trigger"
                            data-icon="eye"
                            @callbackData="onColumnSelect"
                        ></select-option-check>
                    </div>
                    <div class="box-body">
                        <lte-table
                            ref="lte_table"
                            :hdBackground="hdBackground"
                            :data="apartmentClientForBookingList"
                            :columns="apartmentClientForBookingFields"
                            search_filter="left-search"
                            :useFilter="useFilter"
                            :row_mouse_pointer="false"
                            :boxStyle="boxStyle"
                            >
                        </lte-table>
                    </div>
                </div>
            </row>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LTEButton from "@/components/LTEButton.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import LTETable from "@/components/LTETable.vue";
import XLSX from "xlsx";
import utils from '@/lib/utils'
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import BookingStatusEnum from "@/enum/bookingStatusEnum";
import moment from 'moment'
export default {
  name: "LeaseBackResidentClientList",
  data() {
    return {
        apartmentClientForBookingList: [
        ],
        apartmentClientForBookingFields: [
            { text: 'STT', isHidden: true },
            { text: 'apartmentbookings.booking_code', isHidden: true },
            { text: 'apartment.reservations.room', isHidden: true },
            { text: 'leaseback_resident_client.has_breakfast', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.fullname', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.address', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.email', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.phone', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.cmnd_passport', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.cmnd_passport_date', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.dob', isHidden: true },
            { text: 'leaseback_resident_client.ages', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.gender', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.country', isHidden: true },
            { text: 'apartmentbookings.checkin_datetime', isHidden: true },
            { text: 'apartmentbookings.checkout_datetime', isHidden: true },
            { text: 'apartment.status', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.flight', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.visa_number', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.visa_expired_date', isHidden: true },
            { text: 'apartmentbookings.apartment_leaseback_clients.other_details', isHidden: true }
        ],
        columnsApartment: {
            data_list: [],
            itemType: 1,
            showLabel: false,
            modifyFromPosition: "margin-top:-300px",
            cssClassSm1: "col-md-1",
            cssClassSm2: "col-sm-1",
            showAddNew: false
        },
        nations: [
            {
                id: null,
                text: '---'
            },
            {
                id: 287,
                text: 'leaseback_resident_client.domestic'
            },
            {
                id: 9999,
                text: 'leaseback_resident_client.foreign'
            }
        ],
        booking_status_list: [
            {
                id: null,
                text: 'invoice.status'
            },
            {
                id: 1,
                text: 'apartmentbookings.paymentBooking.statusList.checkin'
            },
            {
                id: 2,
                text: 'apartmentbookings.status.checkincommingsoon'
            },
            {
                id: 3,
                text: 'apartmentbookings.status.checked_out'
            }
        ],
        useFilter: false,
        boxStyle: false,
        hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;",
        isLoading: false,
        checkin_datetime: null,
        country_list: [],
        checkout_datetime: null,
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false
        },
        search: {
            booking_status: null,
            apartment_code: null,
            full_name: null,
            booking_code: null,
            domestic_customer: null,
            from_date: null,
            to_date: null,
            flight_no: null
        },
        isHasBreakfast: false
    }
  },
  watch: {
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
        if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
            let newGridColumns = [];
            const viewedColumnsKey = Object.keys(
            this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
            );
            const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
            .viewed_columns;
            if(this.apartmentClientForBookingFields.length == viewedColumns.length) {
                for (let j = 0, sizeOrigin = this.apartmentClientForBookingFields.length; j < sizeOrigin; j++) {
                    for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
                        if (this.apartmentClientForBookingFields[j].text == viewedColumnsKey[i]) {
                            let viewdColumnObject = {};
                            viewdColumnObject.text = viewedColumnsKey[i];
                            viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
                            newGridColumns.push(viewdColumnObject);
                            break;
                        }
                    }
                }
                this.apartmentClientForBookingFields = newGridColumns;
                this.columnsApartment.data_list = this.apartmentClientForBookingFields;
            } else if(this.apartmentClientForBookingFields.length != viewedColumnsKey.length) {
                let updateGridColumns = []
                for (let i = 0; i < this.apartmentClientForBookingFields.length; i++) {
                    for (let j = 0; j < viewedColumnsKey.length; j++) {
                        if(this.apartmentClientForBookingFields[i] != viewedColumnsKey[j]){  
                        let viewdColumnObject = {};
                        viewdColumnObject.text = this.apartmentClientForBookingFields[i].text;
                        viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[j]];
                        updateGridColumns.push(viewdColumnObject);
                        break;
                        }
                    }              
                }
                this.apartmentClientForBookingFields = updateGridColumns;
                this.columnsApartment.data_list = this.apartmentClientForBookingFields;
            }
            
        }
    }
  },
  computed: {
    ...mapGetters([
        "GET_SNACK_BAR",
        "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA"
    ]),
  },
  methods: {
    ...mapActions([
        "SUCCESS_TOAST",
        "ON_SHOW_TOAST",
        "ERROR_TOAST",
        "GET_LEASEBACK_APARTMENT_CLIENT_BOOKING",
        "GET_COUNTRY_LIST",
        "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
        "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
    ]),
    getAges: function(dob) {
        let year_of_dob = utils.formatSqlDate(dob, 'DD/MM/YYYY', 'YYYY')
        let age = !utils.isNull(year_of_dob) ? moment().diff(year_of_dob, "years") : 0
        if (utils.isNull(year_of_dob)) {
            return this.$t('apartment.reservations.adults')
        } else if (!utils.isNull(year_of_dob) && age <= 6) {
            return this.$t('apartment.reservations.children')
        } else if (!utils.isNull(year_of_dob) && age > 6) {
            return this.$t('apartment.reservations.adults')
        } else {
            return ''
        }
    },
    callback: function() {
      this.$router.push({
        name: "CustomerAdd",
        params: {
          id: 0
        },
        query: {
          is_company: false,
          callback: "Customer"
        }
      });
    },
    onChangeStatusBreakfast: function() {
        this.isHasBreakfast = !this.isHasBreakfast
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "leasebackapartmentclientbookinglist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSearchApartmentClientBooking: function() {
        let fromLeaseBackStatisticsOfBreakfastResidentClients = this.$route.params.fromLeaseBackStatisticsOfBreakfastResidentClients
        const data = {
            params: {
                from_date: this.search.from_date,
                to_date: this.search.to_date,
                apartment_code: this.search.apartment_code,
                full_name: this.search.full_name,
                booking_code: this.search.booking_code,
                domestic_customer: this.search.domestic_customer,
                flight_no: this.search.flight_no,
                booking_status: this.search.booking_status,
                is_has_breakfast: this.isHasBreakfast,
                fromLeaseBackStatisticsOfBreakfastResidentClients: !utils.isNull(fromLeaseBackStatisticsOfBreakfastResidentClients) ? fromLeaseBackStatisticsOfBreakfastResidentClients : false
            }
        };
        this.isLoading = true
        this.GET_LEASEBACK_APARTMENT_CLIENT_BOOKING(data).then(
            function(res) {
                let data = res
                this.handleDataLeaseBackApartmentClientBooking(data)
            }.bind(this)
        ).catch(
            function(error) {
                this.isLoading = false
            }.bind(this)
        )
    },
    getStatusBooking: function(bookingStatus, checkIn, checkOut, clientCheckin, clientCheckout) {
        let currentDate = new Date()
        // let checkinDateTime = new Date(checkIn)
        let checkoutDateTime = new Date(checkOut)
        let clientCheckinDateTime = null
        let clientCheckoutDateTime = null
        clientCheckinDateTime = !utils.isNull(clientCheckin) ? new Date(clientCheckin) : clientCheckinDateTime
        clientCheckoutDateTime = !utils.isNull(clientCheckout) ? new Date(clientCheckout) : checkoutDateTime
        if (bookingStatus == BookingStatusEnum.CHECKOUT || currentDate > clientCheckoutDateTime) {
            return this.$t('apartmentbookings.status.checked_out')
        } else if (bookingStatus == BookingStatusEnum.ONBOARD && (!utils.isNull(clientCheckinDateTime) && clientCheckinDateTime <= currentDate && currentDate <= clientCheckoutDateTime)) {
            return this.$t('apartmentbookings.paymentBooking.statusList.checkin')
        } else if (!utils.isNull(clientCheckinDateTime) && clientCheckinDateTime >= currentDate && bookingStatus != BookingStatusEnum.ONBOARD && bookingStatus != BookingStatusEnum.CANCELLED) {
            return this.$t('apartmentbookings.status.checkincommingsoon')
        } else {
            return ''
        }
    },
    handleDataLeaseBackApartmentClientBooking: function(data) {
        this.apartmentClientForBookingList = []
        let stt = 0
        let checkout_expected_datetime = null
        for (let i = 0, size = data.length; i < size; i++) {
            let fullName = ''
            let country = ''
            let gender = ''
            let dob = ''
            let otherDetails = ''
            let passport = ''
            let id_passsport_issued_date = null
            let checkin_datetime = null
            let checkout_datetime = null
            let visa_expired_date = null
            checkout_expected_datetime = utils.formatDateTime(data[i].apt_booking.checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm')
            // No
            stt += 1
            // Get full name
            fullName = data[i].client_details.full_name && data[i].client_details.full_name
            // Get country id and convert to country name
            country = data[i].client_details.country && data[i].client_details.country
            // Get gender id and convert to gender name
            gender = data[i].client_details.gender && data[i].client_details.gender
            // Get dob
            dob = !utils.isNull(data[i].client_details.dob) ? utils.formatDateTime(data[i].client_details.dob, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null
            // Get other details
            otherDetails = data[i].client_details.other_details && data[i].client_details.other_details
            // Get passport
            passport = data[i].client_details.id_passsport && data[i].client_details.id_passsport
            // Get passport due date
            id_passsport_issued_date = data[i].client_details.id_passsport_issued_date
            id_passsport_issued_date = !utils.isNull(id_passsport_issued_date) ? utils.formatDateTime(id_passsport_issued_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : null
            // Visa expired date
            visa_expired_date = data[i].client_details.visa_expired_date
            visa_expired_date = !utils.isNull(visa_expired_date) ? utils.formatDateTime(visa_expired_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : null
            // Check-in date time
            checkin_datetime = data[i].client_details.checkin_datetime
            checkin_datetime = !utils.isNull(checkin_datetime) ? utils.formatDateTime(checkin_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : null
            // Check-out date time
            checkout_datetime = data[i].client_details.checkout_datetime
            checkout_datetime = !utils.isNull(checkout_datetime) ? utils.formatDateTime(checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : checkout_expected_datetime
            let object = {
                'STT': stt,
                'apartmentbookings.booking_code': data[i].apt_booking.booking_code,
                'apartment.reservations.room': data[i].apartment_mapping_with_booking.apartment_details.apartment_code,
                'leaseback_resident_client.has_breakfast': data[i].apartment_mapping_with_booking.has_breakfast == true ? this.$t('report.report_accounting_home_liability.table_result_search.yes') : this.$t('report.report_accounting_home_liability.table_result_search.no'),
                'apartmentbookings.apartment_leaseback_clients.fullname': fullName,
                'apartmentbookings.apartment_leaseback_clients.address': data[i].client_details.address,
                'apartmentbookings.apartment_leaseback_clients.email': data[i].client_details.email,
                'apartmentbookings.apartment_leaseback_clients.phone': data[i].client_details.phone,
                'apartmentbookings.apartment_leaseback_clients.cmnd_passport': passport,
                'apartmentbookings.apartment_leaseback_clients.cmnd_passport_date': id_passsport_issued_date,
                'apartmentbookings.apartment_leaseback_clients.dob': dob,
                'leaseback_resident_client.ages': this.getAges(dob),
                'apartmentbookings.apartment_leaseback_clients.gender': (!utils.isNull(country) && country != '') ? this.getGender(gender) : '',
                'apartmentbookings.apartment_leaseback_clients.country': (!utils.isNull(country) && country != '') ? this.getCountryName(country) : '',
                'apartmentbookings.checkin_datetime': checkin_datetime,
                'apartmentbookings.checkout_datetime': checkout_datetime,
                'apartment.status': this.getStatusBooking(data[i].apt_booking.booking_status, data[i].apt_booking.checkin_datetime, data[i].apt_booking.checkout_datetime, data[i].client_details.checkin_datetime, data[i].client_details.checkout_datetime),
                'apartmentbookings.apartment_leaseback_clients.flight': data[i].client_details.flight,
                'apartmentbookings.apartment_leaseback_clients.visa_number': data[i].client_details.visa_number,
                'apartmentbookings.apartment_leaseback_clients.visa_expired_date': visa_expired_date,
                'apartmentbookings.apartment_leaseback_clients.other_details': otherDetails
            }
            this.apartmentClientForBookingList.push(object)
                // Search
                // if (!utils.isNull(this.search.full_name) && !utils.isNull(this.search.domestic_customer)) {
                //     if (this.search.domestic_customer == 9999) {
                //         if (this.search.full_name.toLowerCase().trim().localeCompare(fullName.toLowerCase().trim()) == 0 && country != 287) {
                //             this.apartmentClientForBookingList.push(object)
                //         }
                //     } else {
                //         if ((this.search.full_name.toLowerCase().trim().localeCompare(fullName.toLowerCase().trim()) == 0) && this.search.domestic_customer == country) {
                //             this.apartmentClientForBookingList.push(object)
                //         }
                //     } 
                // } else if (!utils.isNull(this.search.full_name)) {
                //     if (this.search.full_name.toLowerCase().trim().localeCompare(fullName.toLowerCase().trim()) == 0) {
                //         this.apartmentClientForBookingList.push(object)
                //     }
                // } else if (!utils.isNull(this.search.domestic_customer)) {
                //     if (this.search.domestic_customer == 9999 && country != 287) {
                //         this.apartmentClientForBookingList.push(object)
                //     } else if (this.search.domestic_customer == country) {
                //         this.apartmentClientForBookingList.push(object)
                //     }
                // } else {
                //     this.apartmentClientForBookingList.push(object)
                // }
        }
        this.isLoading = false
    },
    getCountryName: function(country_id) {
        for (let i = 0, size = this.country_list.length; i < size; i++) {
            if (country_id == this.country_list[i].value) {
                return this.country_list[i].text
            }
        }
    },
    getGender(gender) {
        if (gender == 1) {
            return this.$t('customer.gender_type[0]');
        } else if (gender == 2) {
            return this.$t('customer.gender_type[1]');
        } else {
            return this.$t('customer.gender_type[2]');
        }
    },
    formatDateTime: function(dateTime, fromFormat, toFormat) {
        if (!utils.isNull(dateTime)) {
            return utils.formatDateTime(dateTime, fromFormat, toFormat)
        }
    },
    getApartmentClientForBooking: function() {
        let fromLeaseBackStatisticsOfBreakfastResidentClients = this.$route.params.fromLeaseBackStatisticsOfBreakfastResidentClients
        let data = {
            params: {
                checkin_datetime: this.checkin_datetime,
                checkout_datetime: this.checkout_datetime,
                fromLeaseBackStatisticsOfBreakfastResidentClients: !utils.isNull(fromLeaseBackStatisticsOfBreakfastResidentClients) ? fromLeaseBackStatisticsOfBreakfastResidentClients : false
            }
        }
        this.isLoading = true
        this.GET_COUNTRY_LIST().then(
            function(res) {
                let countries = [];
                let dataCountries = res.data;
                dataCountries.forEach(c => {
                    let country = {
                        value: c.id,
                        text: c.country_name
                    }
                    countries.push(country);
                })
                this.country_list = countries;
                this.GET_LEASEBACK_APARTMENT_CLIENT_BOOKING(data).then(
                    function(res) {
                        let data = res
                        this.handleDataLeaseBackApartmentClientBooking(data)
                    }.bind(this)
                ).catch(
                    function(error) {
                        this.isLoading = false
                    }.bind(this)
                )
            }.bind(this)
        ).catch(
            function(error) {
                this.isLoading = false
            }.bind(this)
        )
    },
    onShowModal(checkin_datetime, checkout_datetime) {
        this.checkin_datetime = checkin_datetime
        this.checkout_datetime = checkout_datetime
        $("#modal-lease-back-apartment-client-booking").modal("show")
        this.getApartmentClientForBooking()
    },
    onExport: async function(event, type) {
        event.preventDefault();
        var apartmentClientBooking = XLSX.utils.json_to_sheet(this.apartmentClientForBookingList);
        var range = XLSX.utils.decode_range(apartmentClientBooking['!ref']);
        for(var C = range.s.r; C <= range.e.c; ++C) {
            var address = XLSX.utils.encode_col(C) + "1"; // <-- first row, column number C
            if(!apartmentClientBooking[address]) continue;
            if (apartmentClientBooking[address].v == 'apartmentbookings.booking_code') {
                apartmentClientBooking[address].v = 'Mã Đặt Chỗ'
            } else if (apartmentClientBooking[address].v == 'apartment.reservations.room') {
                apartmentClientBooking[address].v = 'Phòng'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.fullname') {
                apartmentClientBooking[address].v = 'Họ Và Tên'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.address') {
                apartmentClientBooking[address].v = 'Địa Chỉ'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.email') {
                apartmentClientBooking[address].v = 'Email'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.phone') {
                apartmentClientBooking[address].v = 'Điện Thoại'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.cmnd_passport') {
                apartmentClientBooking[address].v = 'CMND/PASSPORT'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.cmnd_passport_date') {
                apartmentClientBooking[address].v = 'Ngày Cấp'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.dob') {
                apartmentClientBooking[address].v = 'Ngày Sinh'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.gender') {
                apartmentClientBooking[address].v = 'Giới Tính'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.country') {
                apartmentClientBooking[address].v = 'Quốc Gia'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.checkin_datetime') {
                apartmentClientBooking[address].v = 'Ngày Vào'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.checkout_datetime') {
                apartmentClientBooking[address].v = 'Ngày Ra'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.flight') {
                apartmentClientBooking[address].v = 'Chuyến Bay'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.visa_number') {
                apartmentClientBooking[address].v = 'Số Visa'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.visa_expired_date') {
                apartmentClientBooking[address].v = 'Ngày Hết Hạn Visa'
            } else if (apartmentClientBooking[address].v == 'apartmentbookings.apartment_leaseback_clients.other_details') {
                apartmentClientBooking[address].v = 'Ghi Chú'
            }
        }
        var wscols = [
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
        ];
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, apartmentClientBooking, "apartmentClientBooking");
        apartmentClientBooking['!cols'] = wscols;
        if (type == 1) {
            // Todo
        } else {
            for (let i = 0, size = this.apartmentClientForBookingFields.length; i < size; i++) {
                if (this.apartmentClientForBookingFields[i].isHidden == false) {
                    apartmentClientBooking['!cols'][i] = { hidden: true };
                }
            }
        }
        // export Excel file
        if (!utils.isNull(this.search.from_date) && !utils.isNull(this.search.to_date)) {
            XLSX.writeFile(wb, `Danh_Sách_Khách_Hàng_Lưu_Trú` + '_' + `${this.search.from_date}` + '_' + `${this.search.to_date}.xlsx`); // name of the file is 'book.xlsx'
        } else {
            XLSX.writeFile(wb, `Danh_Sách_Khách_Hàng_Lưu_Trú.xlsx`);
        }
    },
  },
  mounted() {
    this.columnsApartment.data_list = this.apartmentClientForBookingFields;
    const filter = {
      params: {
        tablename: "leasebackapartmentclientbookinglist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    let fromLeaseBackStatisticsOfBreakfastResidentClients = this.$route.params.fromLeaseBackStatisticsOfBreakfastResidentClients
    if (!utils.isNull(fromLeaseBackStatisticsOfBreakfastResidentClients)) {
        this.isHasBreakfast = true
        this.checkin_datetime = this.$route.params.label
        this.checkout_datetime = this.$route.params.label
        this.search.from_date = this.$route.params.label
        this.search.to_date = this.$route.params.label
    }
    this.getApartmentClientForBooking()
  },
  components: {
    "lte-button": LTEButton,
    "date-picker": datePicker,
    "lte-table": LTETable,
    "select-option-check": SelectOptionCheck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackResidentClientList.vue